<script setup lang="ts">
import DolphinTextInput from '@/components/atoms/DolphinTextInput.vue'
import FlatButton from '@/components/atoms/FlatButton.vue'
import {
  useAddUserVariableDefinitionValueSelectOptionMutation,
  type SettingsPageLineActivationUserVariableDefinitionValueSelectOptionFormOptionFragment,
} from './SettingsPageLineActivationUserVariableDefinitionValueSelectOptionForm.generated'
import { ref } from 'vue'
import { useAlert } from '@/libs/alertPortal'
import SettingsPageLineActivationUserVariableDefinitionValueSelectOptionEditRow from './SettingsPageLineActivationUserVariableDefinitionValueSelectOptionEditRow.vue'

const props = defineProps<{
  userVariableDefinitionGuid: string
  options: SettingsPageLineActivationUserVariableDefinitionValueSelectOptionFormOptionFragment[]
}>()

const emit = defineEmits<{
  (event: 'changed'): void
}>()

const alert = useAlert()

const newInput = ref('')

const addUserVariableDefinitionValueSelectOptionMutation =
  useAddUserVariableDefinitionValueSelectOptionMutation()

const handleClickAddButton = async () => {
  if (newInput.value.length === 0) {
    return
  }

  await addUserVariableDefinitionValueSelectOptionMutation.mutate({
    input: {
      userVariableDefinitionGUID: props.userVariableDefinitionGuid,
      name: newInput.value,
    },
  })

  alert.success('選択肢を追加しました')

  emit('changed')

  newInput.value = ''
}
</script>

<template>
  <section>
    <h1>選択肢</h1>
    <div :class="$style.selectOptions">
      <div :class="$style.selectOptionRow">
        <DolphinTextInput
          v-model="newInput"
          :class="$style.selectOptionRowInput"
          placeholder="追加する選択肢を入力..."
        /><FlatButton
          @click="handleClickAddButton"
          :disabled="newInput.length === 0"
          >追加</FlatButton
        >
      </div>
      <div :class="$style.editRows">
        <SettingsPageLineActivationUserVariableDefinitionValueSelectOptionEditRow
          v-for="option in options"
          :key="option.guid"
          :user-variable-definition-guid="props.userVariableDefinitionGuid"
          :option="option"
          :option-length="options.length"
          @changed="emit('changed')"
        />
      </div>
    </div>
  </section>
</template>

<style module lang="scss">
.selectOptions {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.selectOptionRow {
  display: flex;
  align-items: center;
  gap: 8px;
}

.selectOptionRowInput {
  flex: 1;
  height: 39px;
}

.editRows {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>
